import React from 'react';
import {Layout} from 'antd';

const { Footer} = Layout;
const FooterAdmin = () => (
    <Footer style={{textAlign: 'center'}}>R&D Landing Page ©2020 Created by R&D</Footer>
);

export default FooterAdmin;
